export const DYNAMIC_PROJECT_ID = '508640ee-2a18-4cf5-bf1c-4301ae1b166e';
export const CONTRACT_ADDRESS_PRESALE = '0x1B374E463988BEE73590B88EaF60D9EAb6dbe2A8';
export const CONTRACT_ADDRESS_CASTLE = '0x3946A5f0c0aD124e58e3079A59377E629deF4add';
export const CONTRACT_ADDRESS_NFTVERIFICATION = '0x649AEA91a1C18f2A5d5eB495e87e20FD4C32518a';